import React, { useState, useEffect, useContext } from 'react';
import PageHeader from '../../../components/PageHeader/PageHeader';
import ButtonIcon from '../../../components/ButtonIcon/ButtonIcon';
import Department from './Department';
import Position from './Position';
import ListGrouped from '../../../components/ListGrouped/ListGrouped';
import { API } from '../../../API/API';
import { UserContext } from '../../../context/UserContext';
import { message } from 'antd';
import { MessageConst } from '../../../const/MessageConst';
import { hideLoadScreen, showLoadScreen } from '../../../components/LoadScreen/LoadScreen';
import { constData } from '../../../const/Const';
import { isEdit } from '../../../SharedFunc/User';

const Structure = (props) => {

    const { userInfo } = useContext(UserContext);

    const [filterValue, setFilterValue] = useState('Active');
    const [filterData] = useState(constData.sidepartment_status);

    const [showOU, setShowOU] = useState(false);
    const [showWP, setShowWP] = useState(false);
    const [dKey, setDKey] = useState(1);
    const [data, setData] = useState([]);
    const [depid, setDepId] = useState(-1);
    const [positionid, setPositionId] = useState(-1);

    const [edit] = useState(isEdit(userInfo?.accesstoken, ["HR"]));

    const getData = async (p_filter) => {
        let tData = [];
        showLoadScreen();
        await API.get('/api/humanresource/organization/get_dep_and_pos_list?status=' + p_filter + '&companyid=' + userInfo.companyid.toUpperCase()).then(response => {
            if (response.status == 200 && response.data.rettype === 0) {
                if (response.data?.retdata?.length > 0) {
                    tData = response.data.retdata;
                }

            }
        });
        hideLoadScreen();
        setData(tData);
    }

    useEffect(() => {
        getData(filterValue);
    }, []);

    const onEditP = (p_id) => {
        setDepId(p_id);
        setShowOU(true);
    }

    const onEditC = (p_id) => {
        setPositionId(p_id);
        setShowWP(true);
    }

    const deleteP = async (p_id) => {
        showLoadScreen();
        await API.post('api/humanresource/organization/delete_department?depid=' + p_id).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                getData(filterValue);
            }
        });
        hideLoadScreen();
    }

    const deleteC = async (p_id) => {
        showLoadScreen();
        await API.post('/api/humanresource/organization/delete_position?positionid=' + p_id).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                getData(filterValue);
            }
        });
        hideLoadScreen();
    }

    const inActiveC = async (p_id) => {
        showLoadScreen();
        await API.post('/api/humanresource/Organization/change_status_position?positionid=' + p_id).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                getData(filterValue);
            }
        });
        hideLoadScreen();
    }

    const afterSave = () => {
        setShowOU(false);
        setDepId(-1);
        getData(filterValue);
        setDKey(r => r + 1);
    }

    const afterSavePos = () => {
        setShowWP(false);
        setPositionId(-1);
        getData(filterValue);
    }

    const changeFilter = (p_key, p_name) => {
        setFilterValue(p_key);
        getData(p_key);
    }

    return (
        <div>
            <PageHeader
                showLeftFilter
                changeFilter={changeFilter}
                filterValue={filterValue}
                filterData={filterData}
                title={`Дотоод нэгж, ажлын байр (${data.length})`}
                buttonTitle={edit ? "Дотоод нэгж нэмэх" : null}
                addButton={
                    edit ? <ButtonIcon text="Ажлын байр нэмэх" iconName='Add' onClick={() => { setShowWP(true); }} /> : null
                }
                onButtonClick={() => {
                    setShowOU(true); setDepId(-1);
                }}
            />
            <ListGrouped
                title="Дотоод нэгж, ажлын байр"
                data={data}
                edit={edit}
                onEditP={onEditP}
                onEditC={onEditC}
                deleteP={deleteP}
                deleteC={deleteC}
                inActiveC={inActiveC}
            />
            <Department depid={depid} isOpen={showOU} onDismiss={() => { setShowOU(false); setDepId(-1); }} afterSave={afterSave} dKey={dKey} />
            <Position positionid={positionid} isOpen={showWP} onDismiss={() => { setShowWP(false); setPositionId(-1); }} afterSave={afterSavePos} dKey={dKey} />
        </div>
    );
}

export default Structure;